import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SmoothScroll } from "@/components/hv/SmoothScroll";
import { Header } from "@/components/hv/Header";
import { Footer } from "@/components/hv/Footer";
import { Analytics } from "@/components/hv/Analytics";
import { captureUtm } from "@/lib/utm";
import { loadSettings } from "@/lib/settings";
import { captureRef } from "@/lib/ref";
import HubPage from "@/pages/HubPage";
import NetworkPage from "@/pages/NetworkPage";
import StatsPage from "@/pages/StatsPage";
import ChecklistPage from "@/pages/ChecklistPage";
import KitPage from "@/pages/KitPage";
import PartnersPage from "@/pages/PartnersPage";
import PartnerPortalPage from "@/pages/PartnerPortalPage";
import RunSheetPage from "@/pages/RunSheetPage";
import { Toaster } from "@/components/ui/sonner";

captureUtm();

function App() {
  const [ready, setReady] = useState(false);
  useEffect(() => { Promise.all([loadSettings(), captureRef()]).finally(() => setReady(true)); }, []);
  if (!ready) return <div className="App hv-grain min-h-screen" data-testid="app-loading" />;
  return (
    <div className="App hv-grain">
      <a href="#main" className="hv-skip-link" data-testid="skip-to-content">Skip to content</a>
      <BrowserRouter>
        <Analytics />
        <SmoothScroll>
          <Header />
          <main id="main">
            <Routes>
              <Route path="/" element={<HubPage />} />
              <Route path="/stats" element={<StatsPage />} />
              <Route path="/kit" element={<KitPage />} />
              <Route path="/checklist" element={<ChecklistPage />} />
              <Route path="/partners" element={<PartnersPage />} />
              <Route path="/p/:token" element={<PartnerPortalPage />} />
              <Route path="/runsheet" element={<RunSheetPage />} />
              <Route path="/:network" element={<NetworkPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
